import { makeStyles } from '@gogame/ui/styles';

import { useWidgetResize } from '../hooks';

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    top: ({ top }) => top,
    left: ({ left }) => left,
    width: ({ width }) => width,
    transform: ({ dragged, dragInfo }) =>
      dragged ? `translate(${dragInfo?.x}px, ${dragInfo?.y}px)` : null,
    zIndex: ({ dragged }) => (dragged ? '10' : null),
    transition: ({ dragging }) =>
      dragging ? 'top .3s, left .3s, width .3s' : null,
    pointerEvents: ({ dragging, dragged }) =>
      dragging && !dragged ? 'none' : null,
    userSelect: ({ dragging }) => (dragging ? 'none' : null),
  },
});

const Widget = ({
  id,
  top,
  left,
  width,
  dragInfo,
  dragged,
  dragging,
  children,
}) => {
  const { ref } = useWidgetResize({ id });
  const classes = useStyles({
    top,
    left,
    width,
    dragInfo,
    dragged,
    dragging,
  });

  return (
    <div className={classes.root} ref={ref}>
      {children}
    </div>
  );
};

export default Widget;
